module.exports = __webpack_public_path__ + "static/assets/19ea1146c79e5305c5db33f5e1e78ef3.png";